import { render } from "./SingUp.vue?vue&type=template&id=78f9318b"
import script from "./SingUp.vue?vue&type=script&lang=js"
export * from "./SingUp.vue?vue&type=script&lang=js"

import "./SingUp.vue?vue&type=style&index=0&id=78f9318b&lang=css"

import exportComponent from "/home/marc/E09/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__